<template>
    <div class="card">
        <datatable :tableId="selectedSandbox + 'jobListTable'" :columns="columns" :orderColumn="orderColumn"
            uniqueField="name" :formatColumn="formatColumn" :data="jobList" :deletable="true" :ignoreCache="true"
            @deleteRows="showDeleteSandboxes" :compact="true" :selectCheckboxes="true" :detailColumn="{
                renderBaseUrl: (data) => {
                    return `jobs/${data.name}/configuration`;
                },
            }" />
    </div>
</template>

<script>
import Datatable from "../../components/Datatable.vue";
import { secondsTohms } from '../../utils/commonFunction';
import { mapActions, mapState } from "vuex";

export default {
    components: { Datatable },
    data() {
        return {
            orderColumn: [4, 'desc'],
            columns: [
                {
                    data: "name",
                    title: "Job Name"
                },
                {
                    data: "kind",
                    title: "Job Kind"
                },
                {
                    data: "last_run_started_at",
                    title: "Last Run At"
                },
                {
                    data: "last_run_time",
                    title: "Last Run Time",
                    render: function (data, type, row) {
                        return secondsTohms(data)
                    },
                },
                {
                    data: "last_run_status",
                    title: "Last Run Status"
                },
                {
                    data: "created_by",
                    title: "Created by"
                },
            ],
            formatColumn: [
                {
                    index: 4,
                    type: "datetime"
                }
            ],
        };
    },
    computed: {
        selectedSandbox: {
            get() {
                return this.$store.state.sandbox.currentSandbox;
            }
        },
        sandBoxListOptions() {
            return this.$store.state.sandbox.devSandboxes ? this.$store.state.sandbox.devSandboxes.map((sandbox) => {
                return { "label": sandbox.name, "value": sandbox.name };
            }) : [];
        },
        jobList() {
            let jobList = [];
            this.$store.state.sandbox.sandboxJobs.map((job) => {
                if (job.kind?.toLowerCase() === "pipeline")
                    // skip listing pipeline jobs
                    return;

                let status = job.last_run_status ? job.last_run_status.toLowerCase() : '';
                let statusStr = job.last_run_status;
                if (status === "succeeded" || status === "completed") {
                    statusStr = "<span class='text-success'>●</span> " + job.last_run_status;
                } else if (status === "failed") {
                    statusStr = "<span class='text-danger'>●</span> " + job.last_run_status;
                } else if (status === "running") {
                    statusStr = "<span class='text-primary'>●</span> " + job.last_run_status;
                } else if (status === "submitted") {
                    statusStr = "<span class='text-warning'>●</span> " + job.last_run_status;
                } else if (status === "cancelled") {
                    statusStr = "<span class='text-secondary'>●</span> " + job.last_run_status;
                }
                job["last_run_status"] = statusStr;
                jobList.push(job);
            })
            return jobList;
        }

    },
    async beforeMount() {
        await this.fetchSandboxJobs();
    },


    methods: {
        ...mapActions({
            fetchSandboxJobs: "sandbox/fetchSandboxJobs",
            showModal: "showModal",
        }),
        showDeleteSandboxes(rows) {
            this.showModal({ component: "deleteSandboxJobs", data: rows });
        },
        setCurrentSandbox(sandbox) {
            this.$store.dispatch('sandbox/setCurrentSandbox', sandbox)
        },
    }
};
</script>

<style scoped></style>